// extracted by mini-css-extract-plugin
export var carrierIcon = "_x8-0";
export var carrierLogo = "_x8-1";
export var detailsSection = "_x8-2";